import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './components/auth/LoginPage';
import ForgotPasswordContactPage from './components/auth/ForgotPasswordContactPage';
import ForgotPasswordOtpPage from './components/auth/ForgotPasswordOtpPage';
import ForgotPasswordResetPage from './components/auth/ForgotPasswordResetPage';
import DashboardPage from './pages/DashboardPage';
import ShopsPage from './pages/ShopsPage';
import ShopDetailPage from './pages/ShopDetailPageRedesign';
import PlayersPage from './pages/PlayersPage';
import AgentPlayerDetailPage from './pages/AgentPlayerDetailPage';
import AgentTransactionsPage from './pages/AgentTransactionsPage';
import ProviderFeesPage from './pages/ProviderFeesPage';
import SendShopPopupPage from './pages/SendShopPopupPage';
import SendBroadcastPage from './pages/SendBroadcastPage';
import SettingsPage from './pages/SettingsPage';
import OnlineBalanceTransactionsPage from './pages/OnlineBalanceTransactionsPage';
import FraudIndicatorsPage from './pages/FraudIndicatorsPage';
import CashTransactionsLedgerPage from './pages/cashTransactions/CashTransactionsLedgerPage';
import CashTransactionDetailPage from './pages/cashTransactions/CashTransactionDetailPage';
import {
  AgentPaymentCancelledPage,
  AgentPaymentErrorPage,
  AgentPaymentSuccessPage,
} from './pages/AgentPaymentReturnPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordContactPage />} />
          <Route path="/forgot-password/otp" element={<ForgotPasswordOtpPage />} />
          <Route path="/forgot-password/reset" element={<ForgotPasswordResetPage />} />
          <Route
            path="/"
            element={(
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/transactions"
            element={(
              <ProtectedRoute>
                <AgentTransactionsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/online-transactions"
            element={(
              <ProtectedRoute>
                <OnlineBalanceTransactionsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/cash-transactions"
            element={(
              <ProtectedRoute>
                <CashTransactionsLedgerPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/cash-transactions/:id"
            element={(
              <ProtectedRoute>
                <CashTransactionDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/provider-fees"
            element={(
              <ProtectedRoute>
                <ProviderFeesPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/fraud-indicators"
            element={(
              <ProtectedRoute>
                <FraudIndicatorsPage />
              </ProtectedRoute>
            )}
          />
          <Route path="/purchase" element={<Navigate to="/" replace />} />
          <Route
            path="/popups/send"
            element={(
              <ProtectedRoute>
                <SendShopPopupPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/broadcasts/send"
            element={(
              <ProtectedRoute>
                <SendBroadcastPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/settings"
            element={(
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/payment/success"
            element={(
              <ProtectedRoute>
                <AgentPaymentSuccessPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/payment/cancelled"
            element={(
              <ProtectedRoute>
                <AgentPaymentCancelledPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/payment/error"
            element={(
              <ProtectedRoute>
                <AgentPaymentErrorPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/shops"
            element={(
              <ProtectedRoute>
                <ShopsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/players/:playerId"
            element={(
              <ProtectedRoute>
                <AgentPlayerDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/players"
            element={(
              <ProtectedRoute>
                <PlayersPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/shops/:shopId"
            element={(
              <ProtectedRoute>
                <ShopDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
